function fileNameFromContent(header) {
  const matches = header.match(/filename[^;=\n]*=(((['"]).*?\3)|[^;\n]*)/i);
  if (matches && matches[1]) {
    const filename = matches[1].replace(/['"]/g, "");
    return decodeURIComponent(filename);
  }
  return "unknown";
}

function fileNameFromAttachment(filenameString) {
  const regex = /attachment;\s*(.*)/;
  const matches = regex.exec(filenameString);
  const filename = matches && matches[1];
  return filename ? filename : "unknown";
}

export { fileNameFromContent, fileNameFromAttachment };
